export const ImpoundCategoryType = {
  PROPERTY_TAXES: 'PropertyTaxes',
  SUPPLEMENTAL_INSURANCE: 'Supplemental',
};

export const DISBURSEMENT_PERIOD_MONTHS = 24;
